import { mapGetters } from 'vuex'

import {
  isLoaded,
  brands,
  categories,
  subCategories,
  years,
  seasons,
  markets,
  channels,
  countries,
  divisions,
  departments,
  vendors,
  mills,
  vendorGroups,
  searchCriteria
} from './definition'

export default {
  [isLoaded] (state, getters) {
    return state.isLoaded
  },
  [brands] (state, getters) {
    return state.brands
  },
  [categories] (state, getters) {
    return state.categories
  },
  [subCategories] (state, getters) {
    return state.subCategories
  },
  [years] (state, getters) {
    return state.years
  },
  [seasons] (state, getters) {
    return state.seasons
  },
  [markets] (state, getters) {
    return state.markets
  },
  [channels] (state, getters) {
    return state.channels
  },
  [countries] (state, getters) {
    return state.countries
  },
  [divisions] (state, getters) {
    return state.divisions
  },
  [departments] (state, getters) {
    return state.departments
  },
  [vendors] (state, getters) {
    return state.vendors
  },
  [mills] (state, getters) {
    return state.mills
  },
  [vendorGroups] (state, getters) {
    return state.vendorGroups
  },
  [searchCriteria] (state, getters) {
    return state.searchCriteria
  }
}

export const getters = mapGetters({
  isLoaded,
  brands,
  categories,
  subCategories,
  years,
  seasons,
  markets,
  channels,
  countries,
  divisions,
  vendors,
  departments
})



// WEBPACK FOOTER //
// ./src/components/common/store/getters.js